import { useLocation, Navigate, Outlet } from "react-router-dom";

const RequireAdminAuth = () => {
  const auth = sessionStorage.getItem("isAdmin");
  const location = useLocation();

  return auth ? (
    <Outlet />
  ) : (
    <Navigate to="/admin/login" state={{ from: location }} replace />
  );
};

export default RequireAdminAuth;
